import { useState } from 'react'
import { successToast } from '../../../lib/toastAlert'

export function AddButton(props) {
  const [added, setAdded] = useState(App.State.inReadingList)

  const addToReadingList = () => {
    App.Request.post('/account/reading_list_items', {
      post_id: props.postId,
    })
      .then((response) => {
        if (response.status === 201) {
          setAdded(true)
          successToast({ title: 'Post has been added to your reading list!' })
        } else {
          return null
        }
      })
      .catch(() => null)
  }

  const removeFromReadingList = () => {
    App.Request.delete(`/account/reading_list_items/${App.State.postId}`)
      .then((response) => {
        if (response.status === 204) {
          setAdded(false)
          successToast({
            title: 'Post has been removed from your reading list',
          })
        } else {
          return null
        }
      })
      .catch(() => null)
  }

  const handleAddToReadingList = () => {
    if (added) {
      removeFromReadingList()
    } else {
      addToReadingList()
    }
  }

  return (
    <button
      type="button"
      className="action-button"
      title={added ? 'Remove from reading list' : 'Add to reading list'}
      onClick={() => handleAddToReadingList()}
    >
      <i
        className={
          added ? 'fas fa-bookmark text-primary fa-lg' : 'fal fa-bookmark fa-lg'
        }
      />
    </button>
  )
}
